import React, { useState } from 'react'
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider, TableCell, Typography, FormGroup } from "@material-ui/core";
import DaftarReservasi from './daftarReservasi';
import PopUpReservasi from '../Transaksi/PopUpDetailReservasi';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import api from '../api';
import { format } from 'date-fns';
import ic_detail from '../../assets/ic_detail.png';
import { useHistory } from 'react-router-dom';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Constant from '../../library/Constant';
// import IcFilterList from '@material-ui/icons/FilterList';
import icFilter from '../../assets/ic_filter.png';
import ListReservationFilter from '../components/reservasi/listReservationFilter'

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

// const focusedColor = "#2a9c6c";
// const useStyles = makeStyles((theme) => ({
//     edtText: {
//         // input label when focused
//         "& label.Mui-focused": {
//             color: focusedColor
//         },
//         // focused color for input with variant='standard'
//         "& .MuiInput-underline:after": {
//             borderBottomColor: focusedColor
//         },
//         // focused color for input with variant='filled'
//         "& .MuiFilledInput-underline:after": {
//             borderBottomColor: focusedColor
//         },
//         // focused color for input with variant='outlined'
//         "& .MuiOutlinedInput-root": {
//             "&.Mui-focused fieldset": {
//                 borderColor: focusedColor
//             }
//         }
//     },
//     buttonFind: {
//         color: 'white',
//         backgroundColor: '#2a9c6c',
//     }
// }))


export default function DetailReservasi(props) {
    const history = useHistory()
    // const classes = useStyles()
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    // const [visibleFilter, setVisibleFilter] = React.useState(false);
    const [visibleDetail, setVisibleDetail] = React.useState(false);
    const [validFrom, setValidFrom] = React.useState(null)
    const [validTo, setValidTo] = React.useState(null)
    const [listDokter, setListDokter] = React.useState([])
    const [dataDetail, setDataDetail] = React.useState(null)
    const [idDetail, setIDdetail] = React.useState(null)
    const [emergency, setEmergency] = React.useState(null)
    const [sizeUpload, setSizeUpload] = React.useState(null)
    const [catatanArea, setCatatanArea] = React.useState("")
    const [create, setCreate] = React.useState(false);
    const [read, setRead] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [showFilter, setShowFilter] = React.useState(false);
    const [listDataDokter, setListDataDokter] = useState([])
    const [dataPoli, setDataPoli] = React.useState([])
    const [listScheduleData, setListScheduleData] = useState([])
    const [listScheduleSession, setListScheduleSession] = useState([])
    const [paramQuery, setParamQuery] = React.useState(null)
    const [dataParamQuery, setDataParamQuery] = React.useState(null)

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [dataCount, setDataCount] = useState(10)
    const [loading, setLoading] = React.useState(false)

    // const dokter = useSelector((store) => store.dokterReducer.dokter);
    // const [listPoli, setListPoli] = React.useState(false)
    // const [startFrom, setStartFrom] = React.useState(null)
    // const [tillFrom, setTillFrom] = React.useState(null)
    // const [name, setName] = React.useState("");
    // const [valuePoli, setValuePoli] = React.useState([])
    // const [statusFilter] = React.useState([
    //     { name: 'Book', id: 1 },
    //     { name: 'Reschedule', id: 2 },
    //     { name: 'Check-In', id: 3 },
    //     { name: 'Cancel', id: 4 },
    //     { name: 'Hold', id: 6 },
    // ])

    React.useEffect(() => {
        props.setShowNotif(true)
        getPermission(props)
        if (props && props.reservasi !== "") {
            console.log('masuk sini 1')
            let reservasi = props.reservasi
            if (reservasi.length > 0) {
                let dataTable = []
                reservasi.forEach((item, index) => {
                    let table = []
                    item.data.forEach((i, idx) => {
                        if (i.props) {
                            table.push(i.props.children)
                        } else {
                            table.push(i)
                        }
                    })
                    dataTable.push(table)
                })
                setListDokter(dataTable)
            } else {
                getData(page, limit, paramQuery)
                // getParameter()
            }
        } else {
            console.log('masuk sini 2')
            getData(page, limit, paramQuery)
            // getDataPoli()
        }
        getDataPoli()
        getDataDokter()
        getParameter()
        getDataSession()
    }, [])

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    // setDeleted(data.delete)
                }
            }
        })
    }

    const getParameter = () => {
        api.create().getParameter().then(response => {
            console.log('Get Parameter');
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    response.data.data.forEach((item) => {
                        if (item.param_code === "MAX_FILE_SIZE_APPOINTMENT") {
                            setSizeUpload(Number(item.param_value))
                        }
                        else if (item.param_code === "NOTE_AREA_ON_PRINTING_PAPER") {
                            setCatatanArea(item.param_value)
                            console.log(catatanArea);
                        }
                    })
                }
            }
        })
    }

    const updateDateRange = (a, b) => {
        // console.log(a, b);
        const c = listDokter.filter((item) => {
            // console.log(Number(format(new Date(item[8]), 'yyyyMMdd')));
            return Number(format(new Date(item[9]), 'yyyyMMdd')) >= Number(a) && Number(format(new Date(item[9]), 'yyyyMMdd')) <= Number(b)
        });
        setListDokter(c)
        forceUpdate()

    }

    const getDataPoli = () => {
        api.create().getListMasterPoli().then(response => {
            console.log('Get Poli');
            console.log(response);
            if (response.data) {
                setDataPoli(response.data.data)
            }
            setLoading(false)
        })
    }

    const getDataDokter = () => {
        api.create().getListDokter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.forEach((item) => {
                        if (item.deleted_at === null) {
                            data.push(item)
                        }
                    })
                    setListDataDokter(data)
                    forceUpdate()
                }

            }
        })
    }

    const getDataSession = () => {
        api.create().getScheduleSession().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let scheduleData = []
                    let scheduleSession = []
                    response.data.data.forEach((item) => {
                        item.detail.forEach((items) => {
                            scheduleData.push(items)
                        })
                        item.session.forEach((itemss) => {
                            scheduleSession.push(itemss)
                        })
                    })
                    setListScheduleData(scheduleData)
                    setListScheduleSession(scheduleSession)
                    forceUpdate()
                }

            }
        })
    }

    const getData = (page, limit, _paramQuery, dataParamQuery) => {
        console.log(_paramQuery);
        setParamQuery(_paramQuery)
        if (dataParamQuery) {
            setDataParamQuery(dataParamQuery)
        }
        api.create().getReservasiDokterFilter(`page=${page}&per_page=${limit}${_paramQuery || ""}`).then(response => {
            console.log(response);
            setShowFilter(false)
            let temp = []
            if (response.data) {
                if (response.data.status === true && response.data.data != null) {
                    response.data.data.forEach((item, index) => {
                        let arr = [
                            "",
                            index + 1,
                            item.booking_id,
                            item.doctor_name,
                            item.polyclinics_name,
                            item.patient_name,
                            item.patient_phone,
                            item.patient_mobile_phone,
                            item.queue_number,
                            item.doctor_schedule_date,
                            item.doctor_schedule_date,
                            item.doctor_schedule_time,
                            item.patient_schedule_check,
                            item.payment_option_name,
                            item.reservation_from,
                            item.appointment_status_name,
                            item.is_emergency,
                            item.appointment_id,
                            item.doctor_id,
                            item.doctor_schedule_detail_id,
                            item.doctor_schedule_id,
                        ]
                        temp.push(arr)
                    })
                    setListDokter(temp)
                    forceUpdate()
                    setDataCount(response.data.total_data)
                } else {
                    setListDokter(response.data.data || [])
                    forceUpdate()
                    setDataCount(0)
                }
            }
        })
    }

    const copyText = ({ rowData }) => {
        const id = rowData[rowData.length - 4]
        console.log(id);
        api.create().getDetailReservasiDokter(id).then(response => {
            let data = response.data.data
            let jam = String(data.doctor_schedule).substring(13)
            // console.log(jam);

            let text1 = `Terimakasih telah memilih ${localStorage.getItem(Constant.NAMA_RS)} sebagai Rumah Sakit pilihan anda. Kami dari call center ${localStorage.getItem(Constant.NAMA_RS)} menginformasikan bahwa :\n\nNama Pasien	        : *${data.patient.name}*\nTanggal	   	        : *${format(new Date(data.appointment_date), 'dd-MM-yyyy')}*\nDokter	   	        : *${data.doctor.name}*\nJam Praktek	        : *${jam}*\nNomor Urut	        : *${data.queue_number === null ? "-" : data.queue_number}*\nID Reservasi	        : *${data.booking_id}*\nPembayaran	        : ${data.payment_option_name}\nTempat Registrasi	: B1, B2 , Lobby GMCB dan Petugas Receptionist\nMohon kesediaan bapak / ibu untuk mengisi survey kepuasan pelanggan melalui link dibawah ini, sebagai upaya untuk peningkatan kualitas pelayanan ${localStorage.getItem(Constant.NAMA_RS)} http://linktr.ee/surveyrssc \n\nCATATAN\n1. Mohon untuk melakukan Check-in di Gedung GMCB B1, B2 dan Lobby GMCB menggunakan Id Reservasi yang telah di berikan oleh petugas\n2. Mohon Registrasi 30 menit sebelum jam praktek dokter selesai\n3.Wajib menggunakan Masker\n\nTerimakasih dan salam sehat`
            let text2 = `Terimakasih telah memilih ${localStorage.getItem(Constant.NAMA_RS)} sebagai Rumah Sakit pilihan anda. Kami dari call center ${localStorage.getItem(Constant.NAMA_RS)} menginformasikan bahwa :\n\nNama Pasien	        : *${data.patient.name}*\nTanggal	   	        : *${format(new Date(data.appointment_date), 'dd-MM-yyyy')}*\nDokter	   	        : *${data.doctor.name}*\nJam Praktek	        : *${jam}*\nNomor Urut	        : *${data.queue_number === null ? "-" : data.queue_number}*\nID Reservasi	        : *${data.booking_id}*\nPembayaran	        : ${data.payment_option_name}\nTempat Registrasi	: Loket Jaminan Lt.1 GMCB\nMohon kesediaan bapak / ibu untuk mengisi survey kepuasan pelanggan melalui link dibawah ini, sebagai upaya untuk peningkatan kualitas pelayanan ${localStorage.getItem(Constant.NAMA_RS)} http://linktr.ee/surveyrssc \n\nCATATAN\n1. Mohon untuk melakukan Check-in di Gedung GMCB B1, B2 dan Lobby GMCB menggunakan Id Reservasi yang telah di berikan oleh petugas\n2. Mohon Registrasi 30 menit sebelum jam praktek dokter selesai\n3.Wajib menggunakan Masker\n\nTerimakasih dan salam sehat`
            let text3 = `Terimakasih telah memilih ${localStorage.getItem(Constant.NAMA_RS)} sebagai Rumah Sakit pilihan anda. Kami dari call center ${localStorage.getItem(Constant.NAMA_RS)} menginformasikan bahwa :\n\nNama Pasien	        : *${data.patient.name}*\nTanggal	   	        : *${format(new Date(data.appointment_date), 'dd-MM-yyyy')}*\nDokter	   	        : *${data.doctor.name}*\nJam Praktek	        : *${jam}*\nNomor Urut	        : *${data.queue_number === null ? "-" : data.queue_number}*\nID Reservasi	        : *${data.booking_id}*\nPembayaran	        : ${data.payment_option_name}\nTempat Registrasi	: Loket BPJS Center\nMohon kesediaan bapak / ibu untuk mengisi survey kepuasan pelanggan melalui link dibawah ini, sebagai upaya untuk peningkatan kualitas pelayanan ${localStorage.getItem(Constant.NAMA_RS)} http://linktr.ee/surveyrssc \n\nCATATAN\n1. Mohon untuk melakukan Check-in di Loket BPJS Center menggunakan Id Reservasi yang telah di berikan oleh petugas\n2. Mohon Registrasi 30 menit sebelum jam praktek dokter selesai\n3.Wajib menggunakan Masker\n\nTerimakasih dan salam sehat`
            // console.log(text1);

            let chat = data.payment_option_id === 1 ? encodeURI(text1) : data.payment_option_id === 2 ? encodeURI(text2) : encodeURI(text3)
            if (data.patient.mobile_phone) {
                window.open(`https://wa.me/62${data.patient.mobile_phone}?text=${chat}`, '_blank');
            } else {
                // setMessageAlert("Nomor HP Pasien Tidak Ditemukan")
                // setStatusAlert('warning')
                // setOpenAlert(true)
            }
        })

    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const options = {
        sort: true,
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: false,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: limit,
        count: dataCount,
        responsive: 'scrollMaxHeight',
        serverSide: true,
        onFilterChange: (columnChanged, filterList, c, d, e, f, g) => {
            // console.log(columnChanged, filterList, c, d, e, f, g);
            props.setDataReservasi(e === undefined ? [] : e)
            if (columnChanged === null) {
                setListDokter(null)
                setValidFrom(null)
                setValidTo(null)
                getData(page, limit, paramQuery)
            }
        },
        onTableChange: (action, tableState) => {
            // console.log(action, tableState);
            switch (action) {
                case 'changePage':
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getData(tableState.page + 1, tableState.rowsPerPage, paramQuery)
                    break;
                case 'changeRowsPerPage':
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getData(tableState.page + 1, tableState.rowsPerPage, paramQuery)
                    break;
                case 'sort':
                    // setLoading(true)
                    sorting(tableState)
                    break;
                default:
                    break;
            }
        }
    };

    const sorting = (tableState) => {
        let arr = listDokter
        if (tableState?.sortOrder?.name === 'no') {
            arr.sort(function (a, b) {
                console.log(a[tableState?.activeColumn])
                if (String(tableState?.announceText).includes('descending')) {
                    return a[tableState?.activeColumn] - b[tableState?.activeColumn]
                } else {
                    return b[tableState?.activeColumn] - a[tableState?.activeColumn]
                }
            });
        } else {
            arr.sort(function (a, b) {
                if (String(tableState?.announceText).includes('descending')) {
                    return a[tableState?.activeColumn].localeCompare(b[tableState?.activeColumn]);
                } else {
                    return b[tableState.activeColumn].localeCompare(a[tableState.activeColumn]);
                }
            });
        }
        setListDokter(arr)
        forceUpdate()
    };

    const columns = [
        {
            name: "is_emergency",
            label: "Detail",
            options: {
                sort: false,
                filter: false,
                customHeadRender: (columnMeta) => (
                    <TableCell key={columnMeta.index} style={{}}>
                        <Typography style={{ color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold', textAlign: 'left', marginLeft: 17 }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                onClick={() => handleSeeDetail(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                }}>
                                <img src={ic_detail} style={{ width: 30, height: 30 }} alt='img-detail' />
                            </button>
                            <button
                                onClick={() => copyText(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent'
                                }}>
                                <NotificationsIcon style={{ color: '#65ae92' }} />
                            </button>
                        </div>
                    )
                }
            }
        }, {
            name: "no",
            label: "No",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center', width: 5 }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "booking_id",
            label: "ID Reservasi",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 95 }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_name",
            label: "Nama Dokter",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                filterType: 'textField',
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', width: 150 }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "polyclinics_name",
            label: "Klinik",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "patient_name",
            label: "Nama Pasien",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "patient_phone",
            label: "No HP Pasien",
            options: {
                display: false,
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 120, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "patient_mobile_phone",
            label: "No Telepon Pasien",
            options: {
                display: false,
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 120, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "queue_number",
            label: "No Antrian",
            options: {
                sort: true,
                sortThirdClickReset: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'center', width: 77, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_schedule_date",
            label: "Tanggal",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                filterType: 'custom',
                onTableChange: console.log,
                resetFilter: () => {
                    console.log('masuk');
                },
                onFilterChange: (columnChanged, filterList) => {
                    console.log(`onFilterChange columnChanged: ${columnChanged}`);
                    console.log(filterList);
                },
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (filterList, onChange, index, column) => (
                        <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    margin="normal"
                                    label="Tgl. Reservasi Awal"
                                    format="dd/MM/yyyy"
                                    clearable
                                    value={validFrom}
                                    minDate={new Date()}
                                    onChange={(date) => {
                                        console.log(date);
                                        setValidFrom(date)
                                        if (validTo === null) {
                                            setValidTo(date)
                                        }
                                        date === null ? updateDateRange(format(new Date(), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd')) : updateDateRange(format(new Date(date), 'yyyyMMdd'), validTo === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(validTo), 'yyyyMMdd'))
                                        // forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    ),
                },
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 77, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "doctor_schedule_date",
            options: {
                sort: true,
                sortThirdClickReset: true,
                display: false,
                filterType: 'custom',
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (filterList, onChange, index, column) => (
                        <div>
                            <FormGroup column>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        clearable
                                        label="Tgl. Reservasi Akhir"
                                        format="dd/MM/yyyy"
                                        minDate={validFrom === null ? new Date() : validFrom}
                                        value={validTo}
                                        onChange={(date) => {
                                            setValidTo(date)
                                            if (validFrom === null && date !== null) {
                                                setValidFrom(new Date())
                                            }
                                            if (date === null) {
                                                getData(page, limit, paramQuery)
                                                setListDokter(null)
                                            } else {
                                                updateDateRange(validFrom === null ? format(new Date(), 'yyyyMMdd') : format(new Date(validFrom), 'yyyyMMdd'), format(new Date(date), 'yyyyMMdd'))
                                            }
                                            // forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormGroup>
                        </div>
                    ),
                }
            }
        },
        {
            name: "doctor_schedule_time",
            label: "Sesi Jadwal",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 87, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "patient_schedule_check",
            label: "Jadwal Periksa",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 110, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "payment_option_name",
            label: "Opsi Pembayaran",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 60, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "reservation_from",
            label: "Reservasi Via",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 60, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "appointment_status_name",
            label: "Status",
            options: {
                sort: true,
                sortThirdClickReset: true,
                filter: true,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 60, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
        {
            name: "",
            options: {
                display: false,
                filter: false
            }
        },
    ];

    const onOpen = () => {
        setVisibleCreate(true);
    };

    const onClose = () => {
        setVisibleCreate(false);
        // setVisibleFilter(false);
        setVisibleDetail(false);
    };

    const handleSeeDetail = ({ rowData }) => {
        const id = rowData[rowData.length - 4]
        const emergency = {
            "doctor_schedule_id": rowData[rowData.length - 1],
            "doctor_schedule_detail_id": rowData[rowData.length - 2],
        }
        api.create().getDetailReservasiDokter(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    const data = response.data.data
                    // history.push({
                    //     pathname: '/dokter/detail-reservasi-dokter',
                    //     name: 'Detail Reservasi',
                    //     state: {
                    //         data,
                    //         emergency,
                    //         jadwalPeriksa: data.patient_schedule,
                    //         idDokter: data.doctor.id,
                    //         is_emergency: data.is_emergency,
                    //         id: data.appointment_id,
                    //         intent: 'daftar'
                    //     }
                    // })

                    setDataDetail(data)
                    setEmergency(emergency);
                    setIDdetail(id);
                    setVisibleDetail(true);
                }
            }
        })
    };

    return (
        <div style={{ paddingTop: 10, position: 'relative', height: props.height - 100, overflow: 'auto' }}>
            <div style={{ width: '98%', position: 'absolute', left: 10, top: 15, zIndex: '10', display: 'flex' }}>
                {create && (
                    <button style={{ height: 36, width: 169, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                        onClick={() => onOpen()}
                    >
                        <div onClick={() => history.push({
                            pathname: '/dokter/daftar-reservasi',
                            name: 'Daftar Reservasi',
                            state: {
                                sizeUpload
                            }
                        })} style={{ display: 'flex' }}>
                            <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" alt='img-daftar' />
                            <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 7, color: 'white' }}>Daftar Reservasi</Typography>
                        </div>
                    </button>
                )}
                <div style={{ display: 'flex', position: 'absolute', right: 0 }}>
                    {/* <SearchComponent
                        placeholder={"Ketik disni."}
                        onSearch={(val)=>{
                            setShowFilter(true);
                            console.log(dataPoli)
                            console.log(listDataDokter)
                        }}
                        onDelete={()=>{
                        }}
                    />
                    <IcFilterList/> */}
                    {/* <Button
                        onClick={() => setShowFilter(true)}
                        variant="contained"
                        className={classes.buttonFind}
                        startIcon={<IcFilterList />}
                    >Filter</Button> */}
                    <button onClick={() => setShowFilter(true)} style={{ height: 36, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none', padding: '0 3vw' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img style={{ width: 16, height: 16, marginRight: 7 }} src={icFilter} alt='img-filter' />
                            <Typography style={{ fontSize: 14, margin: '0 3px', color: 'white' }}>Filter Data</Typography>
                        </div>
                    </button>
                </div>
            </div>
            <div style={{ minHeight: 600, width: props.width - (props.open === true ? 370 : 120), marginTop: 55 }}>
                {read && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            columns={columns}
                            data={listDokter}
                            options={options}
                        />
                    </MuiThemeProvider>
                )}
            </div>

            {visibleCreate ?
                <DaftarReservasi
                    onClose={onClose}
                /> : null}
            {visibleDetail ?
                <PopUpReservasi
                    onClose={onClose}
                    getData={() => {
                        getData(page, limit, paramQuery)
                    }}
                    data={dataDetail}
                    id={idDetail}
                    emergency={emergency}
                    update={update}
                />
                : null}

            {showFilter ?
                <ListReservationFilter
                    onClose={() => {
                        setShowFilter(false)
                    }}
                    dataDokter={listDataDokter}
                    dataPoli={dataPoli}
                    dataSession={listScheduleSession}
                    dataSchedule={listScheduleData}
                    onFind={(_paramQuery, dataParamQuery) => {
                        getData(page, limit, _paramQuery, dataParamQuery)
                    }}
                    dataParamQuery={dataParamQuery}
                /> : null}
        </div>
    )
}